import React from "react";

import { Spinner } from "react-bootstrap";
import BackButtom from "../../../../components/backButton";
import FormFactory from "../../../../components/form-factory";

import * as S from "./styles";

import { Fields } from "./fields";
import Icons from "../../../../components/icons-helper";
import { UserProps } from "../../../../../domain/models/user";

type IProps = {
  onSubmit: (values: any, actions: any) => Promise<void>;
  data?: UserProps;
  edit?: boolean;
  loading?: boolean;
  id?: string;
  handleEdit: () => void;
};

const ViewEdit: React.FC<IProps> = ({
  onSubmit,
  data,
  edit,
  loading,
  id,
  handleEdit,
}) => {

  const getTitle = (): string => {
    if (edit && id) {
      return "Editar Admin";
    }
    if (id) {
      return "Voltar";
    }
    return "Novo admin";
  };


  return (
    <S.Wrapper>
      <S.Header>
        <BackButtom text={getTitle()} />

        {!edit && (
          <S.EditButton onClick={handleEdit}>
            <Icons name="edit" width={20} height={20} color="#FFF" />
            <span>
              Editar
            </span>
          </S.EditButton>
        )}
      </S.Header>
      <S.CardContent>
        {!loading && (
          <FormFactory
            groups={Fields(data, edit)}
            onSubmit={onSubmit}
            button={{
              submit: "Salvar",
              submitting: "Salvando...",
              hide: !edit,
            }}
          />
        )}
        {loading && (
          <div className="d-flex justify-content-center">
            <Spinner animation="grow" variant="primary" />
          </div>
        )}
      </S.CardContent>
    </S.Wrapper>
  );
};

export default ViewEdit;
